import { ShippingLevel, ShippingOptionsResult } from "../lulu/LuluPrintTypes";
import { Serializable } from "../util/Serialization";

export class ShippingOption implements Serializable, ShippingOptionsResult {

    _className : string = "ShippingOption";
    className : string = "ShippingOption";
    _deserializeClassName : string = "ShippingOption";
    business_only!: boolean;
    carrier_service_name? : string;
    cost_excl_tax!: string;
    currency!: string;
    home_only!: boolean;
    id!: number;
    level!: ShippingLevel;
    max_delivery_date!: string;
    max_dispatch_date!: string;
    min_delivery_date!: string;
    min_dispatch_date!: string;
    postbox_ok!: boolean;
    total_days_max!: number;
    total_days_min!: number;
    traceable!: boolean;
    transit_time!: number;

    constructor(option : ShippingOptionsResult){
        if(option){
            this.business_only = option.business_only;
            this.carrier_service_name = option.carrier_service_name;
            this.cost_excl_tax = option.cost_excl_tax;
            this.currency = option.currency;
            this.home_only = option.home_only;
            this.id = option.id;
            this.level = option.level;
            this.max_delivery_date = option.max_delivery_date;
            this.max_dispatch_date = option.max_dispatch_date;
            this.min_delivery_date = option.min_delivery_date;
            this.min_dispatch_date = option.min_dispatch_date;
            this.postbox_ok = option.postbox_ok;
            this.total_days_max = option.total_days_max;
            this.total_days_min = option.total_days_min;
            this.traceable = option.traceable;
            this.transit_time = option.transit_time;
        }
    }
    getShortDisplayName(){
        return this.carrier_service_name ? this.carrier_service_name : this.level;
    }
    getFullDisplayName(){
        const base = this.carrier_service_name ? this.carrier_service_name : this.level;
        return `${base} : ${this.total_days_min} - ${this.total_days_max} business days`;
    }
    getIgnoreFields(): string[] {
        return [];
    }
}